import { Hint, HintCloseButton, HintContent, RegularButton } from 'fronton-react';
import React, { FC, PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';
import { useStoreon } from 'storeon/react';
import { State } from 'store/types';
import { getFavoriteAddressHintDisplay, getFavoriteAddressHintVariant } from './get-favorite-address-hint';
import { actionButton, popoverClassName } from './styles';
import { useCityPickerState } from '../../hooks';

export const FAVORITE_ADDRESS_PRIMARY_BUTTON_TEST_ID = 'favorite-address-primary-button';
export const FAVORITE_ADDRESS_SECONDARY_BUTTON_TEST_ID = 'favorite-address-secondary-button';

interface FavoriteAddressHintProps {
  hintShow: boolean;
  onClose: () => void;
}

export const FavoriteAddressHint: FC<PropsWithChildren<FavoriteAddressHintProps>> = ({
  children,
  hintShow,
  onClose,
}) => {
  const { t } = useTranslation();
  const { cookies } = useStoreon<State>('cookies');
  const { onMenuOpen } = useCityPickerState();
  const variant = getFavoriteAddressHintVariant(cookies);
  const { title, paragraph, primaryButtonText, secondaryButtonText } = getFavoriteAddressHintDisplay(
    cookies,
    t,
  );

  const handlePrimaryButtonClick = () => {
    if (variant === 'REGION') {
      onMenuOpen();
    }
    onClose();
  };

  const handleSecondaryButtonClick = () => {
    onMenuOpen();
    onClose();
  };

  const renderActionButton = () => (
    <RegularButton
      className={actionButton}
      variant="primary"
      data-qa={FAVORITE_ADDRESS_PRIMARY_BUTTON_TEST_ID}
      onClick={handlePrimaryButtonClick}
      invert
    >
      {primaryButtonText}
    </RegularButton>
  );

  const renderExtraButton = () => {
    if (!secondaryButtonText) return;

    return (
      <RegularButton
        variant="secondary"
        data-qa={FAVORITE_ADDRESS_SECONDARY_BUTTON_TEST_ID}
        onClick={handleSecondaryButtonClick}
        invert
      >
        {secondaryButtonText}
      </RegularButton>
    );
  };

  return (
    <Hint
      placement="top-start"
      popoverClassName={popoverClassName}
      open={hintShow}
      anchor={<div>{children}</div>}
      actionButton={renderActionButton()}
      extraButton={renderExtraButton()}
      closeButton={<HintCloseButton onClick={onClose} />}
    >
      <HintContent header={title} paragraph={paragraph} />
    </Hint>
  );
};
